import React from 'react';
import { IconProps } from './types';

const Plus2: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 12 12"
  >
    <g fill={!ignoreColor ? color : undefined}>
      <g>
        <rect x={4} width={4} height={12} rx={1} ry={1} />
        <rect
          x={4}
          width={4}
          height={12}
          rx={1}
          ry={1}
          transform="rotate(90 6 6)"
        />
      </g>
    </g>
  </svg>
);

export default Plus2;
